// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var fallback = "_51-5";
export var fallbackIcon = "_51-6";
export var hidden = "_51-2";
export var image = "_51-3";
export var loaded = "_51-4";
export var placeholder = "_51-1";